<template>
  <div id="statement_header"
    :style="{
      color: colors.theme == 'dark' ? `#fff` : `#000`,
      border: colors.theme == 'dark' ? `1px solid #fff` : `1px solid #000`
    }">
    <h1>{{ title }}</h1>
  </div>
</template>

<script>
import { Bus } from "@/event-bus";
export default {
  props: ["title", "index"],

  data: () => ({
    colors: {}
  }),

  created() {
    this.colors = JSON.parse(localStorage.getItem("colors"));
    Bus.$on("addIndex", this.getIndex);
    // console.log(this.index)
  },
  destroyed() {
    Bus.$off("addIndex");
  },

  methods: {
    getIndex() {
      this.index = this.$store.getters.getReportsAgreementIndex;
    }
  }
};
</script>

<style lang="scss">
// #statement_header {
//   display: flex;
//   justify-content: center;
//   flex-direction: column;
//   height: 10%;
//   background-color: #02f0e4;
//   color: #fff;
//   padding: 0 25px;
//   font-size: 20px;
//   font-weight: 700;
//   letter-spacing: 1px;
// }
// @media screen and (max-width: 400px) {
//   #statement_header {
//     font-size: 19px;
//   }
// }
</style>
